<template>
  <v-container>
    <v-row class="my-5">
      <v-col>
        <h3>{{ $t('label.exclusiveSupplier') }}</h3>
        <br />
        <b>Granus s.r.o.</b><br />
        IČO: 27081222 <br />
        DIČ: CZ27081222 <br />
        <a target="_blank" href="https://granus.cz">https://granus.cz</a><br />
      </v-col>
      <v-col>
        <img src="../assets/logo-granus.jpg" width="320" />
      </v-col>
    </v-row>
    <v-row class="my-5">
      <v-col>
        <h3>{{ $t('label.softwareDeveloper') }}</h3>
        <br />
        <b>DigitalData s.r.o.</b><br />
        IČO: 06675867 <br />
        DIČ: CZ06675867 <br />
        <a target="_blank" href="https://www.digitaldata.cz">https://www.digitaldata.cz</a><br />
      </v-col>
      <v-col>
        <img src="../assets/logo-digitaldata.jpg" width="320" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'Company-About',
  data: () => ({}),
});
</script>
